var _line, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobileAroundScmpPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 335,
  height: 430,
  viewBox: "0 0 335 430",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 335,
  y1: 0.501953,
  x2: -4.37114e-8,
  y2: 0.501924,
  stroke: "black"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 16.002,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5265_45412)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 63.002,
  width: 234,
  height: 10,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 85.002,
  width: 234,
  height: 144,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 241.002,
  width: 234,
  height: 55,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 308.002,
  width: 234,
  height: 55,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  y: 375.002,
  width: 234,
  height: 55,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 266,
  y: 63.002,
  width: 234,
  height: 10,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 266,
  y: 85.002,
  width: 234,
  height: 144,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 266,
  y: 241.002,
  width: 234,
  height: 55,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 266,
  y: 308.002,
  width: 234,
  height: 55,
  fill: "#E5E5E5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 266,
  y: 375.002,
  width: 234,
  height: 55,
  fill: "#E5E5E5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5265_45412"
}, /*#__PURE__*/React.createElement("rect", {
  width: 335,
  height: 367,
  fill: "white",
  transform: "translate(0 63.002)"
})))));
export default SvgMobileAroundScmpPlaceholder;